import React, { Component } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import image from "assets/images/companies/img-1.png";

import {
  Badge,
  Col,
  Container,
  Row,
  Table,
  Card,
  CardBody,
  Button,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as moment from "moment";

import {
  DeleteAllNotifications,
  DeleteNotification,
  getNotifications,
  MarkAsRead,
} from "../../store/Notifications/actions";

import { isEmpty, map, size } from "lodash";



class ViewAllNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: [],
    };
    this.onClickDelete = this.onClickDelete.bind(this);
  }

  componentDidMount() {
    const { notifications, onGetNotifications } = this.props;
    onGetNotifications();
    this.setState({ notifications });
  }

  componentDidUpdate(prevProps, prevState) {
    const { notifications } = this.props;

    if (size(notifications) !== size(prevState.notifications)) {
      console.log("update true");
      this.setState({ notifications });
      console.log("notifications after update", notifications);
    } else if (
      JSON.stringify(notifications) !== JSON.stringify(prevState.notifications)
    ) {
      console.log("update stringify true");

      this.setState({ notifications });
      console.log("notifications after update", notifications);
    }
  }

  handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  onClickDelete = id => {
    this.props.onDeleteNotification(id);
  };

  RedirectNotification=(type,id)=>{
    if(type==="Lab Verification"){
      console.log("type clicked:",type)
      this.props.history.push(`/pendingverifications`);
    }
  
    else{
    
    }

  }
  render() {
    const { notifications } = this.state;
    console.log("notification", notifications);
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="DigiLab" breadcrumbItem="Notifications" />

            <Row>
              {/* Add delete button */}
              {!isEmpty(notifications) ? (
                <div className="text-end float-end mb-2">
                  <Button
                    color="danger"
                    className="btn-rounded waves-effect waves-light"
                    onClick={() => this.props.onDeleteAllNotifications()}
                  >
                    Delete All Notifications
                  </Button>
                </div>
              ) : (
                <Row className="justify-content-center mt-5 d-flex flex-column">
                  <Col lg="12">
                    <div className="text-center">
                      <Row className="justify-content-center">
                        <Col sm="6">
                          <h5> You have no new Notifications</h5>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              )}

              {!this.props.isLoading &&
                this.state.notifications.map((notif, key) => (
                  <div key={key}>
                    <Card>
                      <CardBody
                      // onClick={() => this.props.history.push(`/appointments`)}
                      >
                        <Row>
                          <Col lg={11}>
                            <Link to="#" 
                             onClick={() => {
                              this.props.onMarkAsRead(JSON.parse(localStorage.getItem("authUser")).refresh_token,notif.id);
                              this.RedirectNotification(notif.Data.type, notif.Data.id);
                              
                            }}
                            >
                              <h5>
                                {" "}
                                <i className="bx bx-bell"></i> {notif.Title}
                              </h5>
                            </Link>
                          </Col>
                          <Col lg={1} className="float-end">
                            <p>{this.handleValidDate(notif.Date)}</p>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={11}>
                            <h6>{notif.Body}</h6>
                          </Col>
                          <Col lg={1} className="text-end float-end">
                            <i
                              onClick={e => {
                                e.preventDefault();
                                console.log(notif.id);
                                this.props.onDeleteNotification(notif.id);
                              }}
                              className="mdi mdi-trash-can font-size-16 text-danger me-1"
                              style={{
                                cursor: "pointer",
                              }}
                            />

                            {/* <i
                              onClick={e => {
                                e.preventDefault();
                                console.log(notif.id);
                                this.props.onMarkAsRead(notif.id);
                              }}
                              className="bx bx-check-double font-size-16 text-success me-1 mr-1"
                              style={{
                                cursor: "pointer",
                              }}
                            /> */}
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </div>
                ))}
              <Col lg="12"></Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ViewAllNotifications.propTypes = {
  className: PropTypes.any,
  onGetNotifications: PropTypes.func,
  notifications: PropTypes.array,
  isLoading: PropTypes.bool,
  history: PropTypes.any,
  onDeleteNotification: PropTypes.func,
  onDeleteAllNotifications: PropTypes.func,
  onMarkAsRead: PropTypes.func,
};

const mapStateToProps = state => ({

  notifications: state.NotificationsReducer.notifications,
  isLoading: state.NotificationsReducer.isLoading,
});

const mapDispatchToProps = dispatch => ({
  onGetNotifications: () => {
    dispatch(getNotifications());
  },
  onDeleteNotification: id => {
    dispatch(DeleteNotification(id));
  },

  onDeleteAllNotifications: () => {
    dispatch(DeleteAllNotifications());
  },
  onMarkAsRead: (token,id) => {
    dispatch(MarkAsRead(token,id));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewAllNotifications);